import * as React from "react";
import { Button, Modal, Toast } from "react-ui";

import { IForm } from "../../../Engine/Form/IForm";
import { Icon } from "../../../Forms/InjectableModules/InjectableControls";

import { AllSettings, Body, Caption, PrimaryValue, Value, ValueGFV } from "./FormDebugInfoModal.styles";

export interface FormDebugInfoModalProps {
    onClose: () => void;
    form: IForm;
}

export function FormDebugInfoModal(props: FormDebugInfoModalProps): JSX.Element {
    const copyGFV = async () => {
        await navigator.clipboard.writeText(props.form.settings.gfv);
        Toast.push("GFV скопирован!)");
    };
    return (
        <Modal onClose={props.onClose}>
            <Modal.Header>Отладочная информация</Modal.Header>
            <Modal.Body>
                <Body>
                    <PrimaryValue>
                        <Caption>Engine version: </Caption>
                        <Value>{props.form.settings.engineVersion}</Value>
                    </PrimaryValue>
                    <PrimaryValue>
                        <Caption>GFV: </Caption>
                        <ValueGFV onClick={copyGFV}>
                            {props.form.settings.gfv} <Icon name={"DocsTextIcon"} size={16} />
                        </ValueGFV>
                    </PrimaryValue>
                    <h4>All settings</h4>
                    <AllSettings>{JSON.stringify(props.form.settings, undefined, 2)}</AllSettings>
                </Body>
            </Modal.Body>
            <Modal.Footer panel>
                <Button onClick={props.onClose}>Закрыть</Button>
            </Modal.Footer>
        </Modal>
    );
}
